export class WorkflowStepStateModificationNotification {
	public viewId: number;
	public folderId: string;

	public static fromJson(other: any): WorkflowStepStateModificationNotification {
		const instance = new WorkflowStepStateModificationNotification();
		instance.folderId = other.FolderId;
		instance.viewId = other.ViewId;
		return instance;
	}
}
